window.aeloraPrivacyReady = window.aeloraPrivacyReady || new Promise((resolve, reject) => {
  const timer = setTimeout(() => reject(new Error('Privacy API timeout')), 5000);
  const ready = () => { clearTimeout(timer); resolve(window.Shopify.customerPrivacy); };
  if (window.Shopify?.customerPrivacy) { ready(); return; }
  if (!window.Shopify?.loadFeatures) { clearTimeout(timer); reject(new Error('Privacy loader unavailable')); return; }
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (error || !window.Shopify.customerPrivacy) { clearTimeout(timer); reject(error || new Error('Privacy API unavailable')); return; }
    ready();
  });
});
window.aeloraPrivacyReady.catch(() => {});

const trackPreviewLead = async (productId) => {
  try {
    const privacy = await window.aeloraPrivacyReady;
    if (!privacy?.marketingAllowed()) return;

    if (typeof window.fbq === 'function') {
      window.fbq('trackSingle', '2203724513499736', 'Lead', {
        lead_type: 'free_portrait_preview',
        content_ids: productId ? [String(productId)] : [],
        content_type: 'product'
      });
    }
  } catch (error) {
    console.warn('Meta Lead tracking failed:', error);
  }
};


window.AeloraPreviewConfig = Object.assign({ apiBaseUrl: 'https://api.aipresentstore.com/api/v2/portrait-previews', pollMs: 2500, pollMaxMs: 180000 }, window.AeloraPreviewConfig || {});

(() => {
  const storage = {
    get(key) { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} },
    remove(key) { try { localStorage.removeItem(key); } catch {} }
  };
  const styleKey = value => {
    const s = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    if (/olej|oil|realism|realizm|painted/.test(s)) return 'oil';
    if (/akvarel|watercolor|watercolour/.test(s)) return 'watercolor';
    if (/ceruz|pencil|sketch/.test(s)) return 'pencil';
    return null;
  };
  const safeImage = url => { try { const u = new URL(url); return u.protocol === 'https:' ? u.href : ''; } catch { return ''; } };
  let visitorId = storage.get('aelora.preview.visitor');
  if (!visitorId) { visitorId = crypto.randomUUID(); storage.set('aelora.preview.visitor', visitorId); }

  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const scope = root.closest('product-info');
    if (!scope) return;
    const el = key => root.querySelector(`[data-ap-${key}]`);
    const text = JSON.parse(el('text').textContent);
    const variants = JSON.parse(el('variants').textContent);
    const optionNames = JSON.parse(el('options').textContent);
    const styleIndex = optionNames.findIndex(n => /style|štýl|styl/i.test(n));
    const form = document.getElementById(root.dataset.formId);
    const photo = scope.querySelector('[data-photo-upload]');
    const upload = scope.querySelector('[name="properties[upload_id]"]');
    const fileInput = photo?.querySelector('input[type=file]');
    if (!form || !upload || !photo || !fileInput) return;
    photo.insertAdjacentElement('afterend', root);
    const configuredBase = () => root.dataset.apiBase || window.AeloraPreviewConfig.apiBaseUrl || '';
    const storageKey = `aelora.preview.${root.dataset.productId}`;
    const currentVariant = () => variants.find(v => String(v.id) === String(form.querySelector('[name=id]')?.value));
    const currentStyle = () => styleKey(currentVariant()?.options?.[styleIndex]);
    let selected = currentStyle() || 'oil';
    let session = null, token = '', busy = false, epoch = 0, pollTimer, requestKey = '', requestFingerprint = '', revisionKey = '', creating = false;
    let pollStarted = 0;
    const cards = [...root.querySelectorAll('[data-ap-style]')];
    const notice = (message = '', error = false) => { el('notice').textContent = message; el('notice').hidden = !message; el('notice').dataset.error = String(error); };
    const consentInputs = () => ['terms-checkbox','approval-checbox'].map(id => scope.querySelector(`[id="${id}"]`)).filter(Boolean);
    const checkConsents = () => {
      const inputs = consentInputs();
      inputs.forEach(input => { input.closest('label')?.classList.toggle('ap-required', !input.checked); input.setAttribute('aria-invalid', String(!input.checked)); });
      const first = inputs.find(input => !input.checked);
      if (inputs.length !== 2 || first) { notice(text.consent_error, true); first?.scrollIntoView({ behavior: 'smooth', block: 'center' }); first?.focus({preventScroll:true}); return false; }
      return true;
    };
    const getEmail = () => { const input = el('email'); const valid = input.value.trim() && input.checkValidity(); input.setAttribute('aria-invalid', String(!valid)); if (!valid) { notice(text.email_error, true); input.focus(); return null; } return input.value.trim(); };
    const property = (key, value) => {
      let input = form.querySelector(`[name="properties[${key}]"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${key}]`; form.append(input); }
      input.value = value || '';
      input.disabled = !value;
    };
    let selectedImages = {}, gallerySignature = '', sentActions = {};
    const actionId = () => session && activeImage() ? `${session.id}:${activeImage().id}` : '';
    const renderActions = () => {
      const state = sentActions[actionId()] || {};
      const sentLabel = document.documentElement.lang.startsWith('sk') ? 'Odoslané' : 'Sent';
      el('edit').disabled = busy || !!state.revision;
      el('edit').textContent = state.revision ? sentLabel : text.edit;
      el('send').disabled = busy || !!state.revision;
      if (state.revision) el('revision').hidden = true;
      if (el('restore')) { el('restore').hidden = !actionId(); el('restore').disabled = busy || !!state.email; el('restore').textContent = state.email ? sentLabel : text.restore; }
    };
    const activePreview = () => session?.previews?.find(p => p.style === selected);
    const imagesFor = p => Array.isArray(p?.images) ? p.images.filter(i => i?.id && safeImage(i.url)).slice(0, 3) : [];
    const activeImage = () => { const images = imagesFor(activePreview()); return images.find(i => i.id === selectedImages[selected]) || images[0]; };
    const syncProperties = () => {
      const p = activePreview();
      const valid = !!activeImage() && p?.status === 'ready' && currentStyle() === selected && String(upload.value) === String(session?.uploadId);
      property('_aelora_preview_id', valid ? activeImage().id : '');
      property('_aelora_session_id', valid ? session.id : '');
      property('_aelora_preview_style', valid ? p.style : '');
      const image = activeImage();
      const cartSource = image?.previewToken || image?.cartProperties ? image : p;
      const cartProperties = valid ? cartSource?.cartProperties || {} : {};
      property('_preview_token', valid ? cartProperties._preview_token || cartSource?.previewToken || '' : '');
      property('uploadid', valid ? cartProperties.uploadid || '' : '');
      property('_upload_id', valid ? cartProperties._upload_id || '' : '');
    };
    const save = () => { if (session && token) storage.set(storageKey, { id: session.id, token, selected, selectedImages, sentActions, uploadId: session.uploadId }); };
    const updateSelection = index => {
      const images = imagesFor(activePreview());
      if (!images[index]) return;
      selectedImages[selected] = images[index].id;
      el('counter').textContent = `${index + 1} / ${images.length}`;
      el('prev').disabled = index === 0;
      el('next').disabled = index === images.length - 1;
      [...el('dots').children].forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      el('full').src = safeImage(images[index].url);
      syncProperties(); renderActions(); save();
    };
    const moveTo = index => {
      const gallery = el('carousel');
      const slide = gallery.children[index];
      if (!slide) return;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    const renderGallery = () => {
      const images = imagesFor(activePreview());
      const signature = JSON.stringify([selected, images]);
      if (signature === gallerySignature) return;
      gallerySignature = signature;
      const gallery = el('carousel');
      gallery.replaceChildren(); el('dots').replaceChildren();
      images.forEach((image, index) => {
        const slide = document.createElement('button');
        slide.type = 'button'; slide.className = 'ap__art ap__slide';
        slide.setAttribute('aria-label', `${text.zoom} ${index + 1} / ${images.length}`);
        const img = document.createElement('img');
        img.src = safeImage(image.url); img.alt = `${text.result} ${index + 1}`; img.width = 600; img.height = 848;
        const icon = document.createElement('span'); icon.textContent = '↗'; icon.setAttribute('aria-hidden', 'true');
        slide.append(img, icon);
        slide.addEventListener('click', () => { updateSelection(index); el('dialog').showModal(); });
        gallery.append(slide);
        const dot = document.createElement('button'); dot.type = 'button';
        dot.setAttribute('aria-label', `${text.ready} ${index + 1} / ${images.length}`);
        dot.addEventListener('click', () => moveTo(index)); el('dots').append(dot);
      });
      const index = Math.max(0, images.findIndex(i => i.id === selectedImages[selected]));
      updateSelection(index);
      gallery.scrollLeft = gallery.children[index] ? gallery.children[index].offsetLeft - gallery.offsetLeft : 0;
    };
    el('carousel').addEventListener('scroll', () => {
      const gallery = el('carousel');
      if (el('result').hidden || !gallery.children.length) return;
      const positions = [...gallery.children].map(slide => Math.abs(slide.offsetLeft - gallery.offsetLeft - gallery.scrollLeft));
      updateSelection(positions.indexOf(Math.min(...positions)));
    }, {passive:true});
    const relativeMove = delta => { const images = imagesFor(activePreview()); moveTo(Math.max(0, images.findIndex(i => i.id === activeImage()?.id)) + delta); };
    el('prev').addEventListener('click', () => relativeMove(-1));
    el('next').addEventListener('click', () => relativeMove(1));
    el('carousel').addEventListener('keydown', event => { if (['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); relativeMove(event.key === 'ArrowLeft' ? -1 : 1); } });
    const render = () => {
      const p = activePreview();
      const pending = ['queued','processing'].includes(p?.status) || creating;
      const ready = p?.status === 'ready' && imagesFor(p).length === 3;
      cards.forEach(card => {
        const item = session?.previews?.find(p => p.style === card.dataset.apStyle);
        const sample = card.querySelector('.ap__sample');
        sample.style.backgroundImage = item?.status === 'ready' && imagesFor(item)[0] ? `url(${JSON.stringify(safeImage(imagesFor(item)[0].url))})` : '';
        sample.style.backgroundSize = 'cover';
        sample.style.backgroundPosition = 'center 30%';
        card.setAttribute('aria-pressed', String(card.dataset.apStyle === selected));
        card.querySelector('.ap__style-state').textContent = item?.status === 'ready' ? text.ready : ['queued','processing'].includes(item?.status) ? text.pending : text.empty;
        card.disabled = busy;
      });
      root.querySelector('.ap__heading h3').textContent = session ? text.result : text.title;
      el('entry').hidden = !!session && !root.dataset.recovering;
      el('loading').hidden = !pending;
      el('result').hidden = !ready;
      el('create').hidden = !!ready || creating;
      el('create').textContent = pending ? text.check : p?.status === 'failed' ? text.retry : text.create;
      el('create').disabled = busy;
      el('email').disabled = busy;
      el('send').disabled = busy;
      el('buy').disabled = busy || !ready || !currentVariant()?.available;
      root.setAttribute('aria-busy', String(busy || pending));
      if (ready) renderGallery();
      el('consent').hidden = consentInputs().length === 2 && consentInputs().every(i => i.checked);
      syncProperties(); renderActions();
    };
    const api = async (path, { method = 'GET', body, auth = true, key } = {}) => {
      const base = configuredBase().trim().replace(/\/$/, '');
      if (!base) throw Object.assign(new Error(text.unconfigured), { code: 'NOT_CONFIGURED' });
      const u = new URL(base, location.origin);
      if (u.protocol !== 'https:') throw new Error(text.unconfigured);
      const headers = { Accept: 'application/json' };
      if (body) headers['Content-Type'] = 'application/json';
      if (auth && token) headers.Authorization = `Bearer ${token}`;
      if (key) headers['Idempotency-Key'] = key;
      const response = await fetch(`${u.href.replace(/\/$/,'')}${path}`, {method, headers, body: body ? JSON.stringify(body) : undefined, credentials:'omit', referrerPolicy:'no-referrer', signal:AbortSignal.timeout(20000)});
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const messages = { LIMIT_REACHED:text.limit, SESSION_EXPIRED:text.expired, RATE_LIMITED:text.rate };
        throw Object.assign(new Error(messages[data.code] || (response.status === 429 ? text.rate : text.error)), { code:data.code });
      }
      return data;
    };
    const applySession = data => {
      const s = data.session;
      if (!s?.id || !Array.isArray(s.previews) || String(s.productId) !== root.dataset.productId || !s.uploadId) throw new Error(text.error);
      if (session && session.id !== s.id) throw new Error(text.error);
      session = s;
      if (data.accessToken) token = data.accessToken;
      if (!token) throw new Error(text.error);
      save(); render();
    };
    const error = err => {
      notice(err.message || text.error, true);
      if (err.code === 'SESSION_EXPIRED') { storage.remove(storageKey); session = null; token = ''; render(); }
    };
    const poll = async captured => {
      clearTimeout(pollTimer);
      if (!session || captured !== epoch || !root.isConnected) return;
      try {
        const data = await api(`/sessions/${encodeURIComponent(session.id)}`);
        if (captured !== epoch) return;
        applySession(data);
        if (session.previews.some(p => ['queued','processing'].includes(p.status))) {
          if (Date.now() - pollStarted < window.AeloraPreviewConfig.pollMaxMs) pollTimer = setTimeout(() => poll(captured), window.AeloraPreviewConfig.pollMs);
          else notice(text.waiting);
        }
      } catch (err) { if (captured === epoch) error(err); }
    };
    const options = () => Object.fromEntries(optionNames.map((n,i) => [n,currentVariant()?.options[i] || '']));
    const attribution = () => {
      if (!window.Shopify?.customerPrivacy?.marketingAllowed()) return null;
      const result = {}; const params = new URLSearchParams(location.search);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'].forEach(k => { if(params.has(k)) result[k] = params.get(k).slice(0,500); });
      document.cookie.split(';').forEach(c => { const [k,...v] = c.trim().split('='); if (['_fbc','_fbp'].includes(k)) result[k.slice(1)] = v.join('=').slice(0,500); });
      result.pageUrl = `${location.origin}${location.pathname}${location.search}`.slice(0,1000);
      result.referrer = document.referrer.slice(0,1000); return result;
    };
    const setStyle = key => {
      selected = key; el('revision').hidden = true; notice();
      const picker = scope.querySelector('variant-selects');
      const fieldsets = [...(picker?.querySelectorAll('fieldset') || [])];
      const field = fieldsets.find(f => /style|štýl|styl/i.test(f.querySelector('legend')?.textContent || ''));
      const radio = [...(field?.querySelectorAll('input') || [])].find(i => styleKey(i.value) === key);
      if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change',{bubbles:true})); }
      if (!radio) {
        const select = [...(picker?.querySelectorAll('select') || [])].find(s => /style|štýl|styl/i.test(s.name));
        const option = [...(select?.options || [])].find(o => styleKey(o.value) === key);
        if (option && select.value !== option.value) { select.value = option.value; select.dispatchEvent(new Event('change',{bubbles:true})); }
      }
      save(); render();
    };
    cards.forEach(card => card.addEventListener('click', () => setStyle(card.dataset.apStyle)));
    scope.addEventListener('change', event => {
      if (event.target.matches('[name=id]')) { selected = currentStyle() || selected; el('revision').hidden = true; render(); save(); }
      if (consentInputs().includes(event.target)) { event.target.closest('label')?.classList.remove('ap-required'); render(); }
    });
    el('create').addEventListener('click', async () => {
      if (busy) return;
      if (activePreview()?.status === 'ready') return;
      if (['queued','processing'].includes(activePreview()?.status)) { pollStarted = Date.now(); notice(); await poll(epoch); return; }
      const email = session ? null : getEmail();
      if (!session && !email) return;
      if (!upload.value || photo.dataset.photoState === 'uploading') { notice(text.photo_error,true); return; }
      if (!checkConsents()) return;
      if (currentStyle() !== selected) { notice(text.style_mismatch,true); return; }
      const captured = epoch;
      busy = true; creating = true; notice(); render();
      const fingerprint = JSON.stringify([session?.id || null, upload.value, email, selected, currentVariant()?.id, options()]);
      if (requestFingerprint !== fingerprint) { requestKey = crypto.randomUUID(); requestFingerprint = fingerprint; }
      requestKey ||= crypto.randomUUID();
      try {
        const data = session
          ? await api(`/sessions/${encodeURIComponent(session.id)}/previews`, {method:'POST',key:requestKey,body:{style:selected,variantId:String(currentVariant().id),options:options()}})
          : await api('/sessions', {method:'POST',auth:false,key:requestKey,body:{email,visitorId,uploadId:upload.value,productId:root.dataset.productId,variantId:String(currentVariant().id),style:selected,options:options(),consents:{terms:true,photoProcessing:true},attribution:attribution()}});
        if (captured !== epoch) return;
        applySession(data); requestKey = '';
        const leadKey = `aelora.preview.lead.${session.id}`;
        if (data.trackLead === true && !storage.get(leadKey)) { storage.set(leadKey,true); void trackPreviewLead(root.dataset.productId); }
        pollStarted = Date.now(); void poll(captured);
      } catch (err) { if (captured === epoch) error(err); }
      finally { if (captured === epoch) { busy = false; creating = false; render(); } }
    });
    el('buy').addEventListener('click', () => {
      if (!checkConsents()) return;
      if (currentStyle() !== selected) { notice(text.style_mismatch,true); return; }
      syncProperties();
      const button = form.querySelector('[name=add]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') { notice(text.photo_error,true); return; }
      const orderSessionId = session?.id, orderPreviewId = activeImage()?.id, orderAccessToken = token;
      button.click();
      if (orderSessionId && orderPreviewId && orderAccessToken) {
        void fetch(
          `https://api.aipresentstore.com/api/v2/portrait-previews/sessions/${encodeURIComponent(orderSessionId)}/order-click`,
          {
            method: 'POST',
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${orderAccessToken}`
            },
            body: JSON.stringify({ previewId: orderPreviewId }),
            keepalive: true
          }
        ).catch(error => console.warn('Preview order-click tracking failed:', error));
      }
    });
    el('direct').addEventListener('click', () => { const button = form.querySelector('[name=add]'); button?.scrollIntoView({behavior:'smooth',block:'center'}); button?.focus({preventScroll:true}); });
    el('consent').addEventListener('click', checkConsents);
    el('edit').addEventListener('click', () => { if (sentActions[actionId()]?.revision) return; el('revision').hidden = false; revisionKey = ''; el('message').focus(); });
    el('cancel').addEventListener('click', () => { el('revision').hidden = true; el('edit').focus(); });
    el('send').addEventListener('click', async () => {
      const message = el('message').value.trim(), p = activePreview();
      if (busy || !p || p.status !== 'ready' || sentActions[actionId()]?.revision) return;
      if (!message) { notice(text.edit_error,true); el('message').focus(); return; }
      const captured = epoch, sentId = actionId(); busy = true; render(); revisionKey ||= crypto.randomUUID();
      try { await api(`/sessions/${encodeURIComponent(session.id)}/revisions`,{method:'POST',key:revisionKey,body:{previewId:activeImage().id,message}}); if (captured!==epoch) return; sentActions[sentId] = {...sentActions[sentId], revision:true}; save(); el('revision').hidden=true; el('message').value=''; revisionKey=''; notice(text.sent); }
      catch(err) { if(captured===epoch) error(err); }
      finally { if(captured===epoch) {busy=false;render();} }
    });
    el('restore').addEventListener('click', async () => {
      const sentId = actionId(), captured = epoch;
      if (busy || !sentId || sentActions[sentId]?.email) return;
      if (el('entry').hidden) { root.dataset.recovering='1'; el('entry').hidden=false; el('email').focus(); return; }
      const email=getEmail(); if(!email)return;
      busy=true;render();
      try{await api('/recovery',{method:'POST',auth:false,body:{email,productId:root.dataset.productId,visitorId,previewId:activeImage().id}});if(captured!==epoch)return;sentActions[sentId]={...sentActions[sentId],email:true};save();delete root.dataset.recovering;notice(text.restore_sent);}
      catch(err){if(captured===epoch)error(err);}finally{if(captured===epoch){busy=false;render();}}
    });
    el('close').addEventListener('click',()=>el('dialog').close());
    el('dialog').addEventListener('click',e=>{if(e.target===el('dialog'))el('dialog').close();});
    const clear = () => { sentActions={};selectedImages={};gallerySignature='';delete root.dataset.recovering; epoch++;clearTimeout(pollTimer);session=null;token='';busy=false;creating=false;requestKey='';revisionKey='';el('revision').hidden=true;storage.remove(storageKey);notice(text.new_photo);render(); };
    fileInput.addEventListener('change',clear);
    new MutationObserver(() => { if (session && (!upload.value || photo.dataset.photoState === 'empty' || String(upload.value) !== String(session.uploadId))) clear(); }).observe(photo, {attributes:true,attributeFilter:['data-photo-state']});
    scope.addEventListener('aelora:upload-ready',render);
    form.addEventListener('submit', syncProperties, true);
    const restore = async () => {
      const hash=new URLSearchParams(location.hash.slice(1)); const restoreToken=hash.get('aelora_preview');
      const saved=storage.get(storageKey);
      if (!restoreToken && (!upload.value || String(upload.value) !== String(saved?.uploadId))) { storage.remove(storageKey); render(); return; }
      if (!restoreToken && !saved?.token) {render();return;}
      if (!configuredBase()) {render();return;}
      if(restoreToken){history.replaceState(null,'',location.pathname+location.search);}
      const captured=epoch;busy=true;render();
      try{
        if(saved&&!restoreToken){token=saved.token;selected=saved.selected||selected;selectedImages=saved.selectedImages||{};sentActions=saved.sentActions||{};}
        const data=restoreToken ? await api('/restore',{method:'POST',auth:false,body:{token:restoreToken,visitorId}}) : await api(`/sessions/${encodeURIComponent(saved.id)}`);
        if(captured!==epoch)return;
        applySession(data);upload.value=session.uploadId;photo.dataset.photoState='ready';
        photo.querySelector('[data-photo-filename]').textContent=text.uploaded;
        photo.querySelector('[data-photo-error]').textContent='';
        photo.dispatchEvent(new CustomEvent('aelora:preview-restored'));
        setStyle(selected);pollStarted=Date.now();void poll(captured);
      }catch(err){if(captured===epoch)error(err);}
      finally{if(captured===epoch){busy=false;render();}}
    };
    render();void restore();
  }
  const initAll = (scope=document) => scope.querySelectorAll('[data-preview-request]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());else initAll();
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();



